import { Link } from '@mui/material';
import { Link as ReactRouterLink } from 'react-router-dom';

const RouterLink = (props) => <Link component={ReactRouterLink} {...props} />;
export default RouterLink;
